import React, { Component } from "react";
import "./LiveEvent.scss";
import { formatStartTime } from "~/tools/date-utils";
import get from "lodash/get";

import Timer from "~/components/Timer/timer-svg";

class LiveEvent extends Component {
  state = {
    isLive: false
  }

  checkLive = () => {
    this.setState({ isLive: true })
  }

  renderTimer = () => {
    let {
      scheduleStartDate: startTimestamp,
      scheduleEndDate: endTimestamp
    } = this.props.event.gist;

    if (startTimestamp - Date.now() > 60 * 60 * 1000) {
      const formattedStartTime = formatStartTime(startTimestamp);
      return <div className="LiveEvent_starttime">{formattedStartTime}</div>;
    }
    return (
      <div className={`LiveEvent_starttime ${this.state.isLive ? 'live' : ''}`}>
        <Timer
          scheduleStartDate={startTimestamp}
          scheduleEndDate={endTimestamp}
          shortForm={true}
          checkLive={this.checkLive}
        />
      </div>
    );
  };
  render() {
    const { event } = this.props,
      { gist } = event,
      primaryCategory = gist.primaryCategory.title,
      duration = event.tags.find(t => t.tagType === "classDuration"),
      runtime = duration && duration.title;
    const bgImageUrl = get(gist, "imageGist._16x9");
    const liveEventBadgeImageCSS = {
      backgroundImage: `url(${bgImageUrl})`,
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center top"
    };
    return (
      <a className="LiveEvent_link" href={gist.permalink}>
        <div className="LiveEvent" style={liveEventBadgeImageCSS}>
          {runtime && (
            <div className="LiveEvent_runtime">
              {`${runtime.replace(" MIN", "M")} - ${primaryCategory}`}
            </div>
          )}
          {this.renderTimer()}
        </div>
      </a>
    );
  }
}

export default LiveEvent;
